import React, { useEffect, useState, useRef } from 'react';
import { ChevronDown, Check } from 'lucide-react';
import { useContractorFilter, AVAILABLE_CONTRACTORS } from '../contexts/ContractorFilterContext';
import { motion, AnimatePresence } from 'framer-motion';
export function ContractorSelector() {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const {
    selectedContractors,
    isContractorSelected,
    toggleContractor,
    setSelectedContractors
  } = useContractorFilter();
  const allSelected = selectedContractors.length === AVAILABLE_CONTRACTORS.length;
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    }
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }
  }, [isOpen]);
  const getDisplayText = () => {
    if (selectedContractors.length === 0) {
      return 'No Contractors';
    }
    if (allSelected) {
      return 'All Contractors';
    }
    if (selectedContractors.length === 1) {
      return selectedContractors[0];
    }
    return `${selectedContractors.length} Contractors`;
  };
  const handleSelectAll = () => {
    if (allSelected) {
      setSelectedContractors([]);
    } else {
      setSelectedContractors(AVAILABLE_CONTRACTORS);
    }
  };
  return <div className="relative" ref={dropdownRef} data-id="element-86" data-mp="23780dr7gkpcn">
      <button onClick={() => setIsOpen(!isOpen)} className="bg-white text-black text-sm px-3 py-1.5 pr-8 rounded w-48 focus:outline-none focus:ring-2 focus:ring-emerald-500 text-left flex items-center justify-between hover:bg-gray-50 transition-colors" data-id="element-87" data-mp="235wxdtlu7lml">
        <span className="truncate" data-id="element-88" data-mp="1fhx4oo4ytl5d">{getDisplayText()}</span>
        <ChevronDown size={14} className={`absolute right-2 text-gray-500 transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-89" data-mp="1kgzxna7o80wz" />
      </button>

      <AnimatePresence data-id="element-90" data-mp="1cehca0vidh0h">
        {isOpen && <motion.div initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -10
      }} transition={{
        duration: 0.15
      }} className="absolute top-full mt-2 w-72 bg-white rounded-lg shadow-lg border border-gray-200 py-2 z-50 right-0" data-id="element-91" data-mp="17gpewrc3h2ow">
            {/* Select All option */}
            <button onClick={handleSelectAll} className="w-full px-4 py-2 text-left text-sm hover:bg-gray-50 transition-colors flex items-center justify-between border-b border-gray-100 mb-1 pb-3" data-id="element-92" data-mp="13hqd3flntm1o">
              <span className="font-medium text-gray-900" data-id="element-93" data-mp="29whnc9woaj8d">
                {allSelected ? 'Deselect All' : 'Select All'}
              </span>
              {allSelected && <div className="w-4 h-4 bg-emerald-500 rounded flex items-center justify-center" data-id="element-94" data-mp="2hhtlykyic713">
                  <Check size={12} className="text-white" data-id="element-95" data-mp="2mcqrhhwkvy98" />
                </div>}
            </button>

            {/* Individual contractors */}
            {AVAILABLE_CONTRACTORS.map(contractor => {
          const isSelected = isContractorSelected(contractor);
          return <button key={contractor} onClick={() => toggleContractor(contractor)} className="w-full px-4 py-2 text-left text-sm hover:bg-gray-50 transition-colors flex items-center justify-between" data-id="element-96" data-mp="308kszfv0vlcb">
                  <span className={isSelected ? 'text-gray-900' : 'text-gray-600'} data-id="element-97" data-mp="2vdoz0a686nwk">
                    {contractor}
                  </span>
                  {isSelected && <div className="w-4 h-4 bg-emerald-500 rounded flex items-center justify-center" data-id="element-98" data-mp="3nxnif9vweihd">
                      <Check size={12} className="text-white" data-id="element-99" data-mp="2054v0p3of785" />
                    </div>}
                </button>;
        })}

            {/* Footer info */}
            <div className="px-4 py-2 text-xs text-gray-500 border-t border-gray-100 mt-1 pt-3" data-id="element-100" data-mp="1qb4s8tvvae2l">
              {selectedContractors.length} of {AVAILABLE_CONTRACTORS.length}{' '}
              selected
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}